import ServiceManufactory from "../assets/service_manufactory.json"
import ServiceDistributor from "../assets/service_distributor.json"
import ServiceCustomer from "../assets/service_customer.json"
import ServiceLoyalty from "../assets/service_loyalty.json"
import ServiceElearning from "../assets/service_elearning.json"
import ServiceWarehouse from "../assets/service_customize.json"

const search = {
  service: [
    {
      id: 1,
      slug: "smart-manufacturing-platform-nexus",
      title: {
        vi: `Hệ thống Quản lý sản xuất (Nexus)`,
        en: `Smart Manufacturing Platform (Nexus)`,
      },
      title_text: {
        vi: `Hệ thống Quản lý sản xuất (Nexus)`,
        en: `Smart Manufacturing Platform (Nexus)`,
      },
      sub_title: {
        vi: `Quản lý dây chuyền sản xuất & truy xuất nguồn gốc chuỗi cung ứng trên nền tảng kỹ thuật số`,
        en: `Production line management & supply chain traceability on digital platform`,
      },
      lotties: {
        component: ServiceManufactory,
        size: [500, 500],
      },
    },
    {
      id: 6,
      slug: "smart-warehouse-management-system",
      title: {
        vi: `Hệ thống Quản lý kho thông minh`,
        en: `Smart Warehouse Management System (SWMS)`,
      },
      title_text: {
        vi: `Hệ thống Quản lý kho thông minh`,
        en: `Smart Warehouse Management System (SWMS)`,
      },
      sub_title: {
        vi: `Hiện đại hóa nhà kho thành trung tâm kho bãi thông minh, hiệu suất cao`,
        en: `Transform warehouse into a high performance & high efficiency centre`,
      },
      lotties: {
        component: ServiceWarehouse,
        size: [500, 500],
      },
    },
    {
      id: 2,
      slug: "distributor-management-system",
      title: {
        vi: `Hệ thống Quản lý nhà phân phối`,
        en: `Distributor Management System (DMS)`,
      },
      title_text: {
        vi: `Hệ thống Quản lý nhà phân phối`,
        en: `Distributor Management System (DMS)`,
      },
      sub_title: {
        vi: `
                      Cải thiện giao tiếp với đại lý, quản lý đơn hàng, dịch vụ sau bán hàng. 
                      Các đại lý có thể nhận yêu cầu hoặc đơn đặt hàng từ người dùng cuối thông qua ứng dụng di động
                  `,
        en: `
                      Enhance communication quality with dealers, order management & after-sales service. 
                      Dealers can receive inquiry or order from end-users via the mobile app, a model of O<small>2</small>O
                  `,
      },
      lotties: {
        component: ServiceDistributor,
        size: [500, 500],
      },
    },
    {
      id: 3,
      slug: "internal-working-system",
      title: {
        vi: `Hệ thống Quản lý bán hàng trên ứng dụng di động (IWS)`,
        en: `Internal Working System (IWS)`,
      },
      title_text: {
        vi: `Hệ thống Quản lý bán hàng trên ứng dụng di động (IWS)`,
        en: `Internal Working System (IWS)`,
      },
      sub_title: {
        vi: `
                      Phòng thương mại bao gồm bán hàng,
                      dịch vụ khách hàng, marketing có thể tương tác
                      hiệu quả với khách hàng và nâng cao năng lực
                      Quản lý quan hệ khách hàng (CRM)
                  `,
        en: `
                      Help commercial team including sales,
                      customer service, marketing to engage with 
                      customers effectively and enhance the capability of 
                      customer relationship management (CRM)
                  `,
      },
      lotties: {
        component: ServiceCustomer,
        size: [500, 500],
      },
    },
    {
      id: 5,
      slug: "e-learning-platform",
      title: {
        vi: `Hệ thống Giáo dục và Cấp bằng trực tuyến`,
        en: `E-Learning Platform`,
      },
      title_text: {
        vi: `Hệ thống Giáo dục và Cấp bằng trực tuyến`,
        en: `E-Learning Platform`,
      },
      sub_title: {
        vi: `Cung cấp nền tảng giúp người dạy và học kết nối với nhau trực tuyến và nhanh chóng`,
        en: `Online learning & e-Certificate on various digital platforms`,
      },
      lotties: {
        component: ServiceElearning,
        size: [500, 500],
      },
    },
    {
      id: 4,
      slug: "digital-loyalty-program",
      title: {
        vi: `Chăm sóc khách hàng thân thiết trên nền tảng kỹ thuật số`,
        en: `Customer Engagement Platform`,
      },
      title_text: {
        vi: `Chăm sóc khách hàng thân thiết trên nền tảng kỹ thuật số`,
        en: `Customer Engagement Platform`,
      },
      sub_title: {
        vi: `Quản lý khách hàng thân thiết, Khuyến mãi hoàn tiền & Trò chơi tương tác trên nền tảng kỹ thuật số`,
        en: `Customer loyalty management, Cashback promotion & Gamification on digital platform`,
      },
      lotties: {
        component: ServiceLoyalty,
        size: [500, 500],
      },
    },
  ],
};

export default search;
